/* assets/custom-paddles.js */
(() => {

    // LIMIT: Only run this filtering script on the all-paddles collection
  if (!window.location.pathname.includes("/all-paddles")) {
    // Completely disable the script on all other pages
    return;
  }

  const STORAGE_KEY = "paddleSeriesFilter";
  const PARAM_NAME  = "p_series";
  const DEFAULT_SERIES = "all";

  const q  = (sel, scope = document) => scope.querySelector(sel);
  const qa = (sel, scope = document) => Array.from(scope.querySelectorAll(sel));

  // --- Helpers
  function getSeriesFromURL() {
    const usp = new URLSearchParams(location.search);
    return (usp.get(PARAM_NAME) || "").toLowerCase();
  }

  function setSeriesInURL(series) {
    const url = new URL(location.href);
    url.searchParams.set(PARAM_NAME, series);
    history.replaceState({}, "", url);
  }

  function ensureFacetHiddenInput(series) {
    const form = q("form[is='facet-form']");
    if (!form) return;
    let input = form.querySelector(`input[name='${PARAM_NAME}']`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = PARAM_NAME;
      form.appendChild(input);
    }
    input.value = series;
  }

  function reflectActiveButton(series) {
    qa(".paddle-tabs .button").forEach(b => {
      const isActive = (b.dataset.filter || "").toLowerCase() === series;
      b.classList.toggle("active", isActive);
    });
  }

  function applyFilter(series) {
    const normalized = (series || DEFAULT_SERIES).toLowerCase();
    localStorage.setItem(STORAGE_KEY, normalized);
    ensureFacetHiddenInput(normalized);
    setSeriesInURL(normalized);

    reflectActiveButton(normalized);

    qa(".product-list .product-card").forEach(card => {
      const tags = (card.dataset.productTags || "").toLowerCase();
      const show = normalized === "all" || tags.includes(normalized);
      card.style.display = show ? "" : "none";
    });
  }

  function currentSeries() {
    return getSeriesFromURL() || (localStorage.getItem(STORAGE_KEY) || DEFAULT_SERIES).toLowerCase();
  }

  function bindButtons() {
    const buttons = qa(".paddle-tabs .button");
    if (!buttons.length) return;

    buttons.forEach(btn => {
      btn.removeEventListener("click", btn._boundHandler || (()=>{}));

      const handler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const series = (btn.dataset.filter || DEFAULT_SERIES).toLowerCase();
        applyFilter(series);

        // Refresh Judge.me after filter change
        refreshJudgeMe();
      };

      btn._boundHandler = handler;
      btn.addEventListener("click", handler);
    });
  }

  // --- Initialize the grid and Judge.me once the DOM is ready
  function initialize() {
    const series = currentSeries();
    ensureFacetHiddenInput(series);
    bindButtons();
    applyFilter(series);

    // Refresh Judge.me once the DOM is ready
    refreshJudgeMe();
  }

  // --- Helper to safely refresh Judge.me
  function refreshJudgeMe() {
    // jQuery API
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.jdgmRefreshWidgets) {
      window.jQuery.fn.jdgmRefreshWidgets();
      return;
    }

    // fallback: non-jQuery API
    if (typeof window.jdgm !== "undefined" && typeof window.jdgm.initBadges === "function") {
      window.jdgm.initBadges();
    }
  }

  // --- DOM ready
  document.addEventListener("DOMContentLoaded", initialize);

  // --- Facet filter reloads
  document.addEventListener("facet:update", () => {
    waitForReloadAndInit();
    refreshJudgeMe();
  });

  // --- Theme editor lifecycle
  document.addEventListener("shopify:section:load", () => {
    initialize();
    refreshJudgeMe();
  });
  document.addEventListener("shopify:section:select", () => {
    initialize();
    refreshJudgeMe();
  });

  // --- Reliable re-init after DOM replacement
  function waitForReloadAndInit() {
    let observer;
    const checkReady = () => {
      const hasTabs = q(".paddle-tabs .button");
      const hasGrid = q(".product-list .product-card");
      if (hasTabs && hasGrid) {
        observer.disconnect();
        initialize();
      }
    };

    observer = new MutationObserver(checkReady);
    observer.observe(document.body, { childList: true, subtree: true });
  }

   // --- DOM ready
  document.addEventListener("DOMContentLoaded", initialize);

  // --- Facet filter reloads
  document.addEventListener("facet:update", () => {
    waitForReloadAndInit();
    refreshJudgeMe();
  });

  // --- Theme editor lifecycle
  document.addEventListener("shopify:section:load", () => {
    initialize();
    refreshJudgeMe();
  });
  document.addEventListener("shopify:section:select", () => {
    initialize();
    refreshJudgeMe();
  });
})();
